import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { setCheckLists, setHirePaymentStatus as setHirePaymentStatus, setObtainVesselContactDetails, setWhichDocument, SupportSheetSelector } from './reducers/SupportSheetReducer';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import { Button, Grid, TextField } from '@mui/material';
import { CheckList, CheckListHistoryItem, SupportSheetStatus } from './models/SupportSheetModel';
import { SupportSheetCheckListConstant } from './models/SupportSheetCheckListConstant';
import { SupportSheetHelpTextConstant } from './models/SupportSheetHelperTextConstant';
import { portSelectorSelector } from '../PortSelector/reducers/PortSelectorReducer';
import SupportSheetHelpText from './components/SupportSheetHelpText/SupportSheetHelpText';
import SupportSheetHirePaymentStatus, { getDefaultHidePaymentStatus } from './components/SupportSheetHirePaymentStatus/SupportSheetHirePaymentStatus';
import SupportSheetHirePaymentStatusModel from './components/SupportSheetHirePaymentStatus/models/SupportSheetHidePaymentStatusModel';
import SupportSheetCustomCheckbox from './components/SupportSheetCustomCheckbox/SupportSheetCustomCheckbox';
import { SupportSheetEmailContentConstant } from './models/SupportSheetEmailContentConstant';
import EmailEditorModel from '../EmailEditorModal/models/EmailEditorModel';
import Utility from '../../app/utility';
import { contructEmailSubjectPrefix, hasError } from './SupportSheetBiefInformation';
import { PopupEmail } from './SupportSheetPreVoyage';

const SupportSheetOnVoyageTCT: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const supportSheetData = useSelector(SupportSheetSelector);
    const portSelectorData = useSelector(portSelectorSelector);

    const isDontFollowShipment = () => {
        return supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['We dont follow this shipment']) > -1 : false;
    }

    const updateCheckList = (checkListName: string, isAdded: boolean) => {
        let checkList = supportSheetData.model.checkLists ? JSON.parse(supportSheetData.model.checkLists) as CheckList :
            {
                checkListItems: [],
                history: []
            } as CheckList;

        if (isAdded) {
            checkList.checkListItems.push(checkListName);

            //history
            let index = _.findIndex(checkList.history, (item) => {
                return item.name === checkListName;
            });

            if (index === -1) {
                checkList.history.push({
                    name: checkListName.replace(".", ""),
                    date: new Date().toISOString()
                } as CheckListHistoryItem)
            }
        } else {
            let removeIndex = _.indexOf(checkList.checkListItems, checkListName);
            checkList.checkListItems.splice(removeIndex, 1);
        }

        dispatch(setCheckLists(JSON.stringify(checkList)));
    }

    const errorHirePaymentClassName = (enableValidation: boolean, value: string, isDontFollowShipment: boolean = false) => {
        if (isDontFollowShipment) {
            return "";
        }

        if (enableValidation) {
            if (!value || value.length == 0) {
                return "support-sheet-red-text-error";
            }

            let timeSheets = JSON.parse(value) as SupportSheetHirePaymentStatusModel[];
            let hasTimesheet = false;
            _.each(timeSheets, (timesheet) => {
                if (timesheet.from.length > 0 && timesheet.to.length > 0) {
                    hasTimesheet = true;
                }
            })

            return hasTimesheet ? "" : "support-sheet-red-text-error";

        }
        return "";
    }

    return (
        <>
            <CustomAccordion
                title="On Voyage"
                defaultOpen={true}
                open={supportSheetData.model.status == SupportSheetStatus.PreDelivery ||
                    supportSheetData.model.status == SupportSheetStatus.Delivered ||
                    supportSheetData.model.status == SupportSheetStatus.PendingFhs ||
                    supportSheetData.model.status == SupportSheetStatus.PendingCommission ||
                    supportSheetData.model.status == SupportSheetStatus.Cancel ||
                    supportSheetData.model.status == SupportSheetStatus.PendingDisputes
                }
                onOpenChange={(isOpen: boolean) => {
                }}
            >
                <Grid container>
                    <Grid item xs={5}>
                        <Button variant='outlined' color='primary'
                            disabled={isDontFollowShipment()}
                            onClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    let brokerReminder = supportSheetData.model.brokerReminder ?
                                        `\n\nBrokers' reminder: \n- Laycan: ${Utility.DateFormat.formatDateStringFullYear(supportSheetData.model.lay)} - ${Utility.DateFormat.formatDateStringFullYear(supportSheetData.model.can)}` :
                                        "";
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "UPDATE + DELIVERY NOTICE",
                                        emailContent: SupportSheetEmailContentConstant["Ask owners for update + Delivery notice"] + brokerReminder,
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        >
                            Ask owners for update + Delivery notice
                        </Button>
                        &nbsp;
                        <Button variant='outlined' color='primary'
                            disabled={isDontFollowShipment()}
                            onClick={() => {
                                if (supportSheetData.chartererBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.chartererBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.chartererBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "UPDATE + DELIVERY NOTICE",
                                        emailContent: (() => {
                                            let brokerReminder = supportSheetData.model.brokerReminder ?
                                                `Brokers' reminder: \nLaycan: ${Utility.DateFormat.formatDateString(supportSheetData.model.lay)} - ${Utility.DateFormat.formatDateString(supportSheetData.model.can)}` :
                                                "";

                                            return `Please find below vsl update from ownrs fyr:\n++++\n\n++++\n${brokerReminder}`
                                        })(),
                                        receivedName: supportSheetData.chartererBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        >
                            Update to Charterers
                        </Button>
                        <SupportSheetHelpText
                            helpText={SupportSheetHelpTextConstant['Update to Charterers']}
                        ></SupportSheetHelpText>
                    </Grid>
                    <Grid item xs={7}>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={6}>
                        <SupportSheetHirePaymentStatus
                            items={!supportSheetData.model.hirePaymentStatus || supportSheetData.model.hirePaymentStatus.length == 0 ? getDefaultHidePaymentStatus() : JSON.parse(supportSheetData.model.hirePaymentStatus) as SupportSheetHirePaymentStatusModel[]}
                            onChange={(items: SupportSheetHirePaymentStatusModel[]) => {
                                dispatch(setHirePaymentStatus(JSON.stringify(items)));
                            }}
                            errorClassName={errorHirePaymentClassName(supportSheetData.enableValidation, supportSheetData.model.hirePaymentStatus, isDontFollowShipment())}
                            disabled={isDontFollowShipment()}
                        ></SupportSheetHirePaymentStatus>
                    </Grid>
                    <Grid item xs={6}>
                        <div><b>Remarks</b></div>
                        <div>
                            During the whole shipment from handover date till completion of discharging, make sure follow up vsl's movement closely on daily basis. In case sub vessel may miss laycan, please notice Manager/brokers.
                        </div>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Obtain Vessels contact details + LOI format from Owners']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Obtain Vessels contact details + LOI format from Owners'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['Obtain Vessels contact details + LOI format from Owners']}
                            helpText={SupportSheetHelpTextConstant['Obtain Vessels contact details+ LOI format from Owners']}
                            checkboxText={''}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "VESSEL'S CONTACT DETAILS + LOI FORMAT",
                                        emailContent: SupportSheetEmailContentConstant["Obtain Vessels contact details+ LOI format from Owners"],
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                            htmlBeforeText={
                                <>
                                    <span className={(isDontFollowShipment() ? "email-disable" : "")}>
                                        Obtain Vessel's contact details + LOI format from Owners
                                    </span>
                                    <span className='support-sheet-chtrs-owners'>
                                        <TextField
                                            label="Obtain vessel contact details"
                                            fullWidth
                                            disabled={isDontFollowShipment()}
                                            value={supportSheetData.model.obtainVesselContactDetails ? supportSheetData.model.obtainVesselContactDetails : ""}
                                            onChange={(event) => {
                                                dispatch(setObtainVesselContactDetails(event.target.value));
                                            }}
                                            error={
                                                hasError(supportSheetData.enableValidation, supportSheetData.model.obtainVesselContactDetails, isDontFollowShipment())
                                            }
                                            className='cargo-input-component'
                                        />
                                    </span>
                                </>
                            }
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Obtain voyage instruction + onhire bunker survey from Charterers.']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Obtain voyage instruction + onhire bunker survey from Charterers.'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['Obtain voyage instruction + onhire bunker survey from Charterers.']}
                            helpText={SupportSheetHelpTextConstant['Obtain voyage instruction + onhire bunker survey from Charterers.']}
                            checkboxText={'Obtain voyage instruction + onhire bunker survey from Charterers.'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.chartererBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.chartererBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.chartererBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "VOYAGE INSTRUCTION + ON HIRE BUNKER SURVEY",
                                        emailContent: SupportSheetEmailContentConstant["Obtain voyage instruction + onhire bunker survey from Charterers."],
                                        receivedName: supportSheetData.chartererBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['After Delivery, obtain Delivery cert/info + 1st hire invoice']) > -1 : false}
                            disable={isDontFollowShipment()}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['After Delivery, obtain Delivery cert/info + 1st hire invoice'], checked);
                            }}
                            currentCheckedValue={SupportSheetCheckListConstant['After Delivery, obtain Delivery cert/info + 1st hire invoice']}
                            helpText={SupportSheetHelpTextConstant['After Delivery, obtain Delivery cert/info + 1st hire invoice']}
                            checkboxText={'After Delivery, obtain Delivery cert/info + 1st hire invoice'}
                            showSendEmail={false}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Send invoice to Charterer and follow up till Owners receive payment']) > -1 : false}
                            disable={isDontFollowShipment()}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Send invoice to Charterer and follow up till Owners receive payment'], checked);
                            }}
                            currentCheckedValue={SupportSheetCheckListConstant['Send invoice to Charterer and follow up till Owners receive payment']}
                            helpText={SupportSheetHelpTextConstant['Send invoice to Charterer and follow up till Owners receive payment']}
                            checkboxText={'Send invoice to Charterer and follow up till Owners receive payment'}
                            showSendEmail={false}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['During shipment, obtain next invoices when hire is due and follow up till Owners receive payment.']) > -1 : false}
                            disable={isDontFollowShipment()}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['During shipment, obtain next invoices when hire is due and follow up till Owners receive payment.'], checked);
                            }}
                            currentCheckedValue={SupportSheetCheckListConstant['During shipment, obtain next invoices when hire is due and follow up till Owners receive payment.']}
                            helpText={SupportSheetHelpTextConstant['During shipment, obtain next invoices when hire is due and follow up till Owners receive payment.']}
                            checkboxText={'During shipment, obtain next invoices when hire is due and follow up till Owners receive payment.'}
                            showSendEmail={false}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Check cargo will be discharged/released at disport against?']) > -1 : false}
                            disable={isDontFollowShipment()}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Check cargo will be discharged/released at disport against?'], checked);
                            }}
                            currentCheckedValue={SupportSheetCheckListConstant['Check cargo will be discharged/released at disport against?']}
                            helpText={SupportSheetHelpTextConstant['Check cargo will be discharged/released at disport against?']}
                            checkboxText={''}
                            showSendEmail={true}
                            htmlBeforeText={
                                <>
                                    <span className={(isDontFollowShipment() ? "email-disable" : "")}>
                                        Check cargo will be discharged/released at disport against?
                                    </span>
                                    <span className='support-sheet-chtrs-owners'>
                                        <TextField
                                            label="Which Document"
                                            fullWidth
                                            disabled={isDontFollowShipment()}
                                            value={supportSheetData.model.whichDocument ? supportSheetData.model.whichDocument : ""}
                                            onChange={(event) => {
                                                dispatch(setWhichDocument(event.target.value));
                                            }}
                                            error={
                                                hasError(supportSheetData.enableValidation, supportSheetData.model.whichDocument, isDontFollowShipment())
                                            }
                                            className='cargo-input-component'
                                        />
                                    </span>
                                </>
                            }
                            onEmailClick={() => {
                                if (supportSheetData.chartererBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.chartererBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.chartererBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "CARGO DISCHARGING",
                                        emailContent: SupportSheetEmailContentConstant["Check cargo will be discharged/released at disport against?"],
                                        receivedName: supportSheetData.chartererBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Obtained that doc and send to Owners.']) > -1 : false}
                            disable={isDontFollowShipment()}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Obtained that doc and send to Owners.'], checked);
                            }}
                            currentCheckedValue={SupportSheetCheckListConstant['Obtained that doc and send to Owners.']}
                            helpText={SupportSheetHelpTextConstant['Obtained that doc and send to Owners.']}
                            checkboxText={'Obtained that doc and send to Owners.'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "CARGO DISCHARGING",
                                        emailContent: SupportSheetEmailContentConstant["Obtained that doc and send to Owners."],
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Check offhire bunker survey']) > -1 : false}
                            disable={isDontFollowShipment()}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Check offhire bunker survey'], checked);
                            }}
                            currentCheckedValue={SupportSheetCheckListConstant['Check offhire bunker survey']}
                            helpText={SupportSheetHelpTextConstant['Check offhire bunker survey']}
                            checkboxText={'Check offhire bunker survey'}
                            showSendEmail={false}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Check with Chtrs for tentative itinerary + est. Redelivery date.']) > -1 : false}
                            disable={isDontFollowShipment()}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Check with Chtrs for tentative itinerary + est. Redelivery date.'], checked);
                            }}
                            currentCheckedValue={SupportSheetCheckListConstant['Check with Chtrs for tentative itinerary + est. Redelivery date.']}
                            helpText={SupportSheetHelpTextConstant['Check with Chtrs for tentative itinerary + est. Redelivery date.']}
                            checkboxText={'Check with Chtrs for tentative itinerary + est. Redelivery date.'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.chartererBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.chartererBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.chartererBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "TENTATIVE ITINERARY + EST. REDELIVERY NOTICE",
                                        emailContent: SupportSheetEmailContentConstant["Check with Chtrs for tentative itinerary + est. Redelivery date."],
                                        receivedName: supportSheetData.chartererBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Update vessel\'s itinerary + Redelivery notice to Owners']) > -1 : false}
                            disable={isDontFollowShipment()}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Update vessel\'s itinerary + Redelivery notice to Owners'], checked);
                            }}
                            currentCheckedValue={SupportSheetCheckListConstant['Update vessel\'s itinerary + Redelivery notice to Owners']}
                            helpText={SupportSheetHelpTextConstant['Update vessel\'s itinerary + Redelivery notice to Owners']}
                            checkboxText={'Update vessel\'s itinerary + Redelivery notice to Owners'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "TENTATIVE ITINERARY + EST. REDELIVERY NOTICE",
                                        emailContent: SupportSheetEmailContentConstant["Update vessel\'s itinerary + Redelivery notice to Owners"],
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                    </Grid>
                </Grid>
            </CustomAccordion>
        </>
    )
};

export default SupportSheetOnVoyageTCT;